export default "/images/custom_development/apple_design_resources__image.png";